import { ReactiveVar } from '@apollo/client';
import { User } from '../../../generated/graphql';

export default function setCurrentUser(currentUserVar: ReactiveVar<User | null>) {
  return (user: User) => {
    currentUserVar(user ?? null);
  };
}
